export const API_ENDPOINTS={
    ALL_HOLIDAY: {
        FETCH_ALL_HOLIDAYS: (month, state, location, type) => {
            const queryParams = new URLSearchParams();
            if (month) queryParams.append("month", month);
            if (state) queryParams.append("state", state);
            if (location) queryParams.append("location", location);
            if (type) queryParams.append("type", type);
          
            const queryString = queryParams.toString();
            return queryString ? `/holidays/all-holidays?${queryString}` : `/holidays/all-holidays`;
          },
          
            FETCH_SETTINGS: ({ referenceName}) =>
                `/settings?referenceName=${referenceName}`,
            FETCH_STATE: () =>
                `/country/states`,
      }
      
      
};